import { channels } from "@/mocks/guaData";

const quickNav = [
  { href: "#hot", label: "今日热瓜榜" },
  { href: "#reply", label: "吃瓜神回复" },
  { href: "#review", label: "评论区神评" },
  { href: "#scene", label: "名场面弹幕梗" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于呱呱" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-douban-line", label: "豆瓣" },
  { icon: "ri-mail-line", label: "邮箱" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50">
                <i className="ri-chat-smile-2-line"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">呱呱吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              评论区才是瓜的精华。我们把中文互联网评论区的高赞神评、神回复与名场面精选归档，让你看热闹就看这层楼。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/20 text-base text-background-100 transition-colors hover:border-background-50/50 hover:bg-primary-700"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          {/* 频道 */}
          <nav aria-label="频道导航">
            <h4 className="text-sm font-semibold text-background-50">吃瓜频道</h4>
            <ul className="mt-4 space-y-2.5">
              {channels.map((c) => (
                <li key={c.name}>
                  <a href="#reply" className="text-sm text-background-200 transition-colors hover:text-secondary-200">
                    {c.name}神评
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 快速导航 */}
          <nav aria-label="快速导航">
            <h4 className="text-sm font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {quickNav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-background-200 transition-colors hover:text-secondary-200">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 投稿联系 */}
          <div>
            <h4 className="text-sm font-semibold text-background-50">投稿吃瓜</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              发现了神级神回复或名场面？投稿上来，让更多人一起笑。
            </p>
            <a
              href="#contact"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-accent-400"
            >
              <i className="ri-send-plane-line"></i>
              去投稿
            </a>
            <p className="mt-4 text-xs text-background-300">投稿邮箱：fan@guaguachigua.cn</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© 2026 呱呱吃瓜 · 评论区才是瓜的精华 · 理性吃瓜，快乐冲浪</p>
          <p>本站内容来自公开网络评论区精选，仅供娱乐交流</p>
        </div>
      </div>
    </footer>
  );
}